var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineUiCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82, 18) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.45,
    d: "M23 0c4.97 0 9 4.03 9 9v10.828C40.23 23.33 46 31.492 46 41c0 12.703-10.297 23-23 23S0 53.703 0 41c0-9.509 5.77-17.67 14-21.173V9c0-4.97 4.03-9 9-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 41,
    r: 17,
    fill: "#4DB5FF",
    fillOpacity: 0.65,
    stroke: "#78C7FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D7EEFF",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M29 34v18H17V34h12z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D7EEFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 29.5L26 29.5"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.941 13.893L4.941.099M.309 4.732L4.941.099 9.574 4.732",
    transform: "translate(18 5)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineUiCameraIcon);
export default __webpack_public_path__ + "static/media/line-ui-camera-icon.6fad9e73.svg";
export { ForwardRef as ReactComponent };